// extracted by mini-css-extract-plugin
module.exports = {"container":"StatusIcons_container__4NnyY","wrapper":"StatusIcons_wrapper__1XGGJ","text":"StatusIcons_text__2OrhT","listIcon":"StatusIcons_listIcon__3szjk"};